<ul class="nav nav-pills gap-2 mb-4">
  <li class="nav-item">
    <button class="nav-link" (click)="menu.emit()">Menu</button>
  </li>
  <li class="nav-item">
    <button class="nav-link" [class.active]="aba === 'registrador'" (click)="selecionar.emit('registrador')">Registrador</button>
  </li>
  <li *ngIf="adminGlobal" class="nav-item">
    <button class="nav-link" [class.active]="aba === 'empregador'" (click)="selecionar.emit('empregador')">Empregador</button>
  </li>
  <li class="nav-item">
    <button class="nav-link" [class.active]="aba === 'departamentos'" (click)="selecionar.emit('departamentos')">Departamentos</button>
  </li>
  <li class="nav-item">
    <button class="nav-link" [class.active]="aba === 'funcionario'" (click)="selecionar.emit('funcionario')">Funcionario</button>
  </li>
  <li class="nav-item">
    <button class="nav-link" [class.active]="aba === 'relogio'" (click)="selecionar.emit('relogio')">Relogio de ponto</button>
  </li>
  <li class="nav-item">
    <button class="nav-link" [class.active]="aba === 'exportacao'" (click)="selecionar.emit('exportacao')">Exportacao</button>
  </li>
  <li class="nav-item">
    <button class="nav-link" [class.active]="aba === 'pendencias'" (click)="selecionar.emit('pendencias')">Pendencias</button>
  </li>
  <li class="nav-item">
    <button class="nav-link" [class.active]="aba === 'ajustes'" (click)="selecionar.emit('ajustes')">
      Ajustes
      <span class="badge text-bg-warning ms-1" *ngIf="ajustesPendentes">{{ ajustesPendentes }}</span>
    </button>
  </li>
  <li *ngIf="adminGlobal" class="nav-item">
    <button class="nav-link" [class.active]="aba === 'usuarios'" (click)="selecionar.emit('usuarios')">Usuarios</button>
  </li>
  <li class="nav-item">
    <button class="nav-link" [class.active]="aba === 'auditoria'" (click)="selecionar.emit('auditoria')">Auditoria</button>
  </li>
  <li class="nav-item ms-auto">
    <button class="nav-link" (click)="sair.emit()">Sair</button>
  </li>
</ul>
